import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MasterDataService } from '../../services/master-data.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-annual-stipend-report',
  templateUrl: './annual-stipend-report.component.html',
  styleUrls: ['./annual-stipend-report.component.css']
})
export class AnnualStipendReportComponent implements OnInit {
  financialYearList;
  articleNameList;
  branchList;
  selectedFinancialYear;
  selectedBranch;
  selectArticle;
  isBranchSelected = false;
  isPartnerSelected = true;
  annualStipendReportList = [];
  partnerList;
  selectedPartner;
  selectedFromClosing;
  selectedToClosing;
  closingDateList;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService,
    private branchFilterService: BranchFilterService
  ) { }

  ngOnInit(): void {

    this.selectedFinancialYear = "";
    this.selectArticle = "";
    this.selectedPartner="";
    this.selectedFromClosing = "";
    this.selectedToClosing = "";
    this.loadInitDetails();
  }

  loadInitDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialYearList = res;
    });
  }

  onYearselected() {
    this.branchList = [];
    this.articleNameList = [];
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
const branches = res as any[];
const userBranchId = Number(localStorage.getItem('branchId'));

this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
});

    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
          console.log('closing date list', this.closingDateList);
        });
    }
  }

  onBranchSelected() {
    this.articleNameList = [];
    if (
      this.selectedBranch.length != 0 &&
      this.selectedBranch != null
    ) {
    this.loadPartnerList();
    }
  }

  loadPartnerList(){
    const branchId = this.selectedBranch.map(({ id }) => id);
    this.masterDataService
      .getUserPartnersOfBranch(branchId)
      .subscribe((res) => {
        console.log('select partner', res);
        this.partnerList = res;
      });
  }

  onPartnerSelected(){
    this.loadArticleList();
  }

  loadArticleList() {
    var branchId = this.selectedBranch.map(({ id }) => id);
    console.log('branchID', branchId);
    // this.masterDataService.getArticleListByYearBranch(this.selectedFinancialYear.id,branchId).subscribe((resp: any) => {
    //   console.log('article list by branch', resp);
    //   this.articleNameList = resp;
    // });
    if (
      this.selectedPartner != '' &&
      this.selectedPartner != undefined &&
      this.selectedPartner != null
    ) {

      var selectedPartnersId = this.selectedPartner.map(({ id }) => id);
      console.log('partnerID', selectedPartnersId);

      this.masterDataService
        .getArticlesByReportingPartner(selectedPartnersId)
        .subscribe((res) => {
          console.log('userList', res);
          this.articleNameList = res;
        });
    }
  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected);
    this.isBranchSelected = !this.isBranchSelected;
    this.onBranchSelected();
  }

  selectAllArticleName(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected);
    this.isBranchSelected = !this.isBranchSelected;
  }

  selectAllPartner(select: NgModel, values) {
    this.selectedPartner = values;

    this.selectAll(select, values, this.isPartnerSelected);
    this.isPartnerSelected = !this.isPartnerSelected;
    this.onPartnerSelected();
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  showExportToExcelButton: boolean;
  userId;
  partnersId;
  calculateAllTotal;
  onViewReport() {
    this.calculateAllTotal = 0;
    var total = 0;
    if (this.selectedFinancialYear == "" || this.selectedFinancialYear == null || this.selectedFinancialYear == undefined ||
      this.selectedBranch == null || this.selectedBranch.length == 0 ||
      this.selectArticle == null || this.selectArticle.length == 0 ||
      this.selectedFromClosing == undefined || 
      this.selectedFromClosing == '' ||
       this.selectedFromClosing == null ||
      this.selectedToClosing == undefined ||
       this.selectedToClosing == '' ||
        this.selectedToClosing == null) {
       this.commonMessageService.swalAlertWithoutIcon('',"Please select all value.");
      return;
    }
    this.userId = this.selectArticle.map(({ id }) => id);
    this.partnersId = this.selectedPartner.map(({ id }) => id);
    this.masterDataService.getAnnualStipendReport(this.selectedFinancialYear.id, this.userId,this.partnersId,this.selectedFromClosing.closingDate,this.selectedToClosing.closingDate).subscribe((resp: any) => {
      console.log('annual stipend report details', resp);
      this.annualStipendReportList = resp;
      this.annualStipendReportList.map((res: any) => {
        total = total + res.netStipend;
        this.calculateAllTotal = Math.round(total);
      })
      if (this.annualStipendReportList.length > 0) {
        this.showExportToExcelButton = true;
      } else {
         this.commonMessageService.swalAlertWithoutIcon('',"No Record Found.");
      }
    });
  }

  exportToExcelClick() {
    var partnersId = this.selectedPartner.map(({ id }) => id);
    this.masterDataService.getAnnualStipendReportExcel(this.selectedFinancialYear.id, this.userId,partnersId).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "AnnualStipendReport.xlsx";
      link.click();
    });
  }

  exportToPDFClick() {
    let docDefinition = {
      info: { title: 'Annual Stipend Report' },
      pageOrientation: 'landscape',
      content: [
        { text: 'P G BHAGWAT LLP, Chartered Accountants', style: 'header' },
        { text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', style: 'header1' },
        {
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 70, 70, 70, 70, 'auto', 'auto', 'auto'],
            body: [
              [{ text: 'Article name', style: 'headerStyle' },
              { text: '	Partner Name', style: 'headerStyle' },
              { text: 'Month', style: 'headerStyle' },
              { text: 'Amount of stipend', style: 'headerStyle' },
              { text: 'Late diary submission penalty', style: 'headerStyle' },
              { text: 'Late leave submission penalty', style: 'headerStyle' },
              { text: 'Conveyance', style: 'headerStyle' },
              { text: 'Scholarship', style: 'headerStyle' },
              { text: 'Travel allowance', style: 'headerStyle' },
              { text: 'Total', style: 'headerStyle' }],

              ...this.annualStipendReportList.map(r => ([{ text: `${r.firstName} ${r.middleName} ${r.lastName}` }, r.partnerName, r.monthName,
              r.stipend, r.diaryPenalty, r.leavePenalty, r.conveyance, r.scholarship, r.travelAllowance, r.netStipend])),
              //   // ...this.reportList.map(r => ([{ text: `${r.client}`, rowSpan: r.assignments.length}, r.assignments.map(a => [{ text: `${a.assignment}`, rowSpan: a.task.length }]), r.assignments.map(a => a.task.map(t => [t.task])), r.assignments.map(a => a.task.map(t => [t.days]))])),
              [{ text: 'Total', style: 'alltotalStyle' },
              { text: '', style: 'alltotalStyle' },
              { text: '', style: 'alltotalStyle' },
              { text: '', style: 'alltotalStyle' },
              { text: '', style: 'alltotalStyle' },
              { text: '', style: 'alltotalStyle' },
              { text: '', style: 'alltotalStyle' },
              { text: '', style: 'alltotalStyle' },
              { text: '', style: 'alltotalStyle' },
              { text: `${this.calculateAllTotal}`, style: 'alltotalStyle' },
              ]]
          },
          // layout: 'noBorders'
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
        },
        header1: {
          alignment: 'center',
          margin: [0, 0, 0, 20]
        },
        headerStyle: {
          fillColor: '#17a2b8 !important',
          color: 'white',
          margin: [8, 8, 8, 8],
          fontSize: 14,
          bold: true,
        },
        alltotalStyle: {
          fillColor: '#e1f4f7',
          margin: [0, 5, 0, 5],
        },
      }
    }
    pdfMake.createPdf(docDefinition).download('AnnualStipendReport.pdf');
  }

}
